export const API_ENDPOINTS = {
    POLICIES: {
        GET_POLICY_BY_ID: "Policy/GetById",
        SEARCH_POLICY: "Policy/Search",
        EXPORT_POLICY: "Policy/Export",
        SAVE_POLICY: "/Policy/Save",
        UPDATE_POLICY: "/Policy/Update",
        DELETE_POLICY: "Policy/Delete",
        ACTIVATE_POLICY: "Policy/Activate",
        CANCEL_POLICY: "Policy/Cancel",
        GET_POLICY_DETAIL: "Policy/GetDetailById",
    },
    // Add other modules like EMPLOYEE, DEPARTMENT etc.
};

export const QUERY_KEYS = {
    POLICIES: {
        Policy: ["PolicySearch"], // UNIQUE IN OVER ALL APPLICATION
    },
};